import React from 'react';
import Landing2Layout from './layout/Landing2Layout';
import PageHero2 from './components/PageHero2';
import { FEATURES, FeatureCard } from './sections2/Features2';
import Comparison2 from './sections2/Comparison2';
import HowItWorks2 from './sections2/HowItWorks2';
import CTABand2 from './sections2/CTABand2';

/**
 * Página Características. Hero + las 6 capacidades (tarjetas), el comparativo
 * «PaySlip sí / no», los 3 pasos y la CTA de cierre. Las ilustraciones animadas
 * bespoke de cada tarjeta llegan en la Fase 5 (los keyframes ya viven en landing2.css).
 */
const Caracteristicas2 = () => (
  <Landing2Layout title="Características — PaySlip">
    <PageHero2
      eyebrow="Características"
      title="Todo lo que PaySlip hace"
      accent="por ti"
      subtitle="Un puente automático entre el SAT y tu equipo: descarga tus recibos ya timbrados y los entrega a quien los necesita. Sin capturar, sin calcular, sin timbrar."
    />
    <section style={{ maxWidth: 1200, margin: '0 auto', padding: 'clamp(32px,5vw,56px) clamp(20px,5vw,40px) clamp(48px,7vw,88px)' }}>
      <div className="ls2-grid3">
        {FEATURES.map((f) => <FeatureCard key={f.title} {...f} />)}
      </div>
    </section>
    <Comparison2 />
    <HowItWorks2 />
    <CTABand2
      title="Pruébalo con tus propios recibos"
      subtitle="15 días de prueba. Conecta tu e.firma y mira cómo llegan solos."
    />
  </Landing2Layout>
);

export default Caracteristicas2;
